
export default function () {

    // スマホ用：メニュー開閉ボタン
    $('.js-header-btn').on('click', function () {
        close_menu();
        return false;
    });

    // メニューのボタンを押した
    $('.c-mainmenu a.js-pagescroll').on('click', close_menu);
    $('.js-header-logo').on('click', close_menu);


    function close_menu(e) {
        const $target = $('.js-header-pop-target');
        const status = $target.attr('data-sp-menu');

        $target.attr('data-sp-menu', status !== 'open' ? 'open' : 'close');
        $('.js-header-btn').attr('data-sp-menu', status !== 'open' ? 'open' : 'close');
    }

    // // サブメニュー開閉
    // let $nowsubmenu = null;
    // $('.js-mainmenu-link-sub').on('click', function () {
    //     const $parent = $(this).parent();
    //     if ($parent.attr('data-submenu-open') === 'true') {
    //         $parent.attr('data-submenu-open', 'false');
    //     } else {
    //         if ($nowsubmenu) {
    //             $nowsubmenu.attr('data-submenu-open', 'false');
    //         }
    //         $parent.attr('data-submenu-open', 'true');
    //         $nowsubmenu = $parent;
    //     }
    //     return false;
    // });
}



// WEBPACK FOOTER //
// ./js/module/menu.js